<template>
  <span :class="['skew-inline-main text-white skew-button', color]" :style="setWidth()" @click="handleClick">
    <span class="skew-inline">{{text}}</span>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    color: {
      type: String,
      default: 'bg-red'
    },
    width: {
      type: String
    }
  },

  computed: {
    isPX () {
      return typeof this.width === 'string' ? this.width.includes('px') : false
    },

    isPercent () {
      return typeof this.width === 'string' ? this.width.includes('%') : false
    }
  },

  methods: {
    setWidth () {
      let widthCss = null
      if (this.isPX || this.isPercent) {
        widthCss = this.width
      } else {
        widthCss = `${this.width}px`
      }

      return this.width ? { width: widthCss } : { width: 'auto' }
    },

    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.skew-button { padding: 5px 10px; cursor: pointer;}
.skew-inline { transform: skew(30deg);}
.skew-inline-main { transform: skew(-30deg); border-radius: 3px;}
</style>
